import React from "react";
import "../OrderComponents/OrderTabs.css";
import { useState } from "react";
import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import api from "../../seller-apis/api";

const QuestionTabs = (props) => {
  const stateData = useSelector((state) => state);
  
  const [ordersCount, setOrdersCount] = useState(null);

  const location = useLocation();
  var path = location.pathname.split("/");
  const pageName = path[path.length - 1];

  
  
  return (
    <div className="new-tabs">
      <div className="tab-container" style={{ position: "relative" }}>
          <NavLink
            to="pending"
            className={`tabs ${pageName == "pending" ? "active" : ""}`}
          >
            Pending Questions
            <div class="order-menu-count menu-count-border">
              {props.pendingCount || 0}
            </div>
          </NavLink>
          <NavLink
            to="answered"
            className={`tabs ${pageName == "answered" ? "active" : ""}`}
          >
            Answered Questions
            <div class="order-menu-count menu-count-border">
              {props.answeredCount || 0}
            </div>
          </NavLink>
          <NavLink
            to="ignored"
            className={`tabs ${pageName == "ignored" ? "active" : ""}`}
          >
            Ignored Questions
            <div class="order-menu-count menu-count-border">
              {props.ignoredCount || 0}
            </div>
          </NavLink>
      </div>
    </div>
  );
};

export default QuestionTabs;
